import { connect } from 'react-redux';
import OrdersHeader from './widgets/header';
import OrdersDatagrid from './widgets/OrdersDatagrid';

const OrdersListPage = () => {
  return (
    <div>
      <OrdersHeader />
      <OrdersDatagrid />
    </div>
  );
};

const mapStateToProps = (state) => ({ tickets: state.tickets });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersListPage);
